<template>
    <div class="pc-chain flex-between">
        <div class="col-box first-col flex-between-stright">
            <div class="item-box flex-left">
                <i class="iconfont iconBTY"></i>
                <div class="txt">
                    <p class="txt-title">BTY {{ $t("home.nPrice") }}</p>
                    <p>$ {{ btyInfo.usd }}</p>
                </div>
            </div>
            <div class="item-box flex-left">
                <i class="iconfont iconpingjunchukuai"></i>
                <div class="txt flex-between-stright-left">
                    <p class="flex-left">
                        <span
                            class="txt-title"
                            style="display: inline-block; width: 85px"
                            >{{ $t("home.avgspeed") }}</span
                        >
                        {{
                            btyInfo.perTime > 0
                                ? btyInfo.perTime.toFixed(2)
                                : 5.01
                        }}
                        s
                    </p>
                    <p class="flex-left">
                        <span
                            class="txt-title"
                            style="display: inline-block; width: 85px"
                            >{{ $t("home.perTxns") }}</span
                        >
                        {{ (btyInfo.perTxCount || 5.7).toFixed(2) }}
                    </p>
                </div>
            </div>
        </div>
        <div class="col-box second-col flex-between-stright">
            <div class="item-box flex-left">
                <i class="iconfont icondangqianzongliang"></i>
                <div class="txt">
                    <p class="flex-left">
                        <span
                            class="txt-title"
                            style="display: inline-block; max-width: 90px"
                            >{{ $t("home.nNum") }}</span
                        >
                        {{ parseInt(btyInfo.totalSum) | filterNum }} BTY
                    </p>
                    <p class="flex-left">
                        <span
                            class="txt-title"
                            style="display: inline-block; max-width: 90px"
                            >{{ $t("home.nMValue") }}</span
                        >
                        $
                        {{
                            parseInt(btyInfo.totalSum * btyInfo.usd) | filterNum
                        }}
                    </p>
                </div>
            </div>
            <div class="item-box flex-left">
                <i class="iconfont iconjiaoyibishu"></i>
                <div class="txt">
                    <p class="txt-title">{{ $t("home.txCount") }}</p>
                    <p>
                        {{ parseInt(btyInfo.txCount) | filterNum }}
                        {{ $t("home.bi") }}
                    </p>
                </div>
            </div>
        </div>
        <div class="col-box third-col">
            <kline></kline>
        </div>
    </div>
</template>
<script>
import Kline from "./Kline";
import chainBase from "@/mixins/Home/chainInfo.js";
export default {
    mixins: [chainBase],
    components: {
        Kline,
    },
};
</script>

<style lang="scss" scoped>
.pc-chain {
    z-index: 200;
    position: absolute;
    width: 1200px;
    height: 227px;
    bottom: -75px;
    padding: 10px;
    background: rgba(255, 255, 255, 0.24);
    box-shadow: 0px 2px 4px 0px rgba(210, 210, 210, 0.24);
    border-radius: 2px;
    .col-box {
        height: 207px;
        .item-box {
            width: 317px;
            height: 98px;
            background: $white;
            padding: 15px 0 15px 20px;
            font-size: 14px;
            .iconfont {
                margin-right: 20px;
                color: #6368de;
                font-size: 38px;
            }
            .txt {
                color: $black;
                p:last-child {
                    margin-top: 10px;
                }
                .txt-title {
                    margin-right: 15px;
                    color: $font_grey;
                }
            }
        }
    }
    .first-col,
    .second-col {
        width: 317px;
    }
}
</style>
